<template>
	<div id="login">
		<transition name="fade">
			<div v-if="performingRequest" class="loading">
				<p>Loading...</p>
			</div>
		</transition>
		<div class="background">
			<img src="../assets/images/pink-blue.jpg" />
		</div>
		<div class="wrapper middle center">
			<div class="table-row">
				<img class="logo-content" src="../assets/images/logo.png" />
			</div>
			<div class="table-row">
				<span :class="{'active': 'showLoginForm'}" @click="toggleForm">Log In</span>
				<span :class="{'active': '!showLoginForm'}" @click="toggleForm">Sign Up</span>
			</div>
			<div class="table-row" :class="{ 'signup-form': !showLoginForm && !showForgotPassword }">
				<form class="auth-form" v-if="showLoginForm" @submit.prevent>
					<div class="input-div">
						<label for="email1">Email</label>
						<input v-model.trim="loginForm.email" type="text" placeholder="test@email.com" id="email1" />
					</div>
					<div class="input-div">
						<label for="password1">Password</label>
						<input v-model.trim="loginForm.password" type="password" placeholder="******" id="password1" />
						<a class="form-link" @click="togglePasswordReset">Forgot Password</a>
					</div>

					<button @click="login" class="yellow-button">Log In</button>
					<a class="form-extra-link" @click="toggleForm">Create Account</a>
				</form>
				<form class="auth-form" v-if="!showLoginForm && !showForgotPassword" @submit.prevent>
					<div class="input-div">
						<label for="name">Username</label>
						<input v-model.trim="signupForm.name" type="text" placeholder="username123" id="name" />
					</div>
					<div class="input-div">
						<label for="email2">Email</label>
						<input v-model.trim="signupForm.email" type="text" placeholder="you@email.com" id="email2" />
					</div>
					<div class="input-div">
						<label for="password2">Password</label>
						<input v-model.trim="signupForm.password" type="password" placeholder="min 6 characters" id="password2" />
					</div>
						<button @click="signup" class="yellow-button">Sign Up</button>
						<a class="form-extra-link" @click="toggleForm">Log In</a>
				</form>
				<form v-if="showForgotPassword" @submit.prevent class="password-reset">
					<div v-if="!passwordResetSuccess">
						<h1>Reset Password</h1>
						<p>We will send you an email to reset your password</p>

						<label for="email3">Email</label>
						<input v-model.trim="passwordForm.email" type="text" placeholder="you@email.com" id="email3" />

						<button @click="resetPassword" class="button">Submit</button>

						<div class="extras">
							<a @click="togglePasswordReset">Back to Log In</a>
						</div>
					</div>
					<div v-else>
						<h1>Email Sent</h1>
						<p>check your email for a link to reset your password</p>
						<button @click="togglePasswordReset" class="button">Back to login</button>
					</div>
				</form>
			</div>
			<transition name="fade">
				<div v-if="errorMsg !== ''" class="table-row error-msg">
					<p>{{ errorMsg }}</p>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
    const fb = require('../../server/firebaseConfig.js');
    export default {
        data() {
            return {
                loginForm: {
                    email: '',
                    password: ''
                },
                signupForm: {
                    name: '',
                    title: '',
                    email: '',
                    password: ''
                },
                passwordForm: {
                    email: ''
                },
                showLoginForm: true,
                showForgotPassword: false,
                passwordResetSuccess: false,
                performingRequest: false,
                errorMsg: ''
            }
        },
        methods: {
            toggleForm() {
                this.errorMsg = ''
                this.showLoginForm = !this.showLoginForm
            },
            togglePasswordReset() {
                if (this.showForgotPassword) {
                    this.showLoginForm = true;
                    this.showForgotPassword = false;
                    this.passwordResetSuccess = false;
                } else {
                    this.showLoginForm = false;
                    this.showForgotPassword = true;
                }
            },
            login() {
                this.performingRequest = true;
                fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
                    this.$store.commit('setCurrentUser', user);
                    this.$store.dispatch('fetchUserProfile');
                    this.performingRequest = false;
                    this.$router.push('/dashboard');
                }).catch(err => {
                    console.log(err);
                    this.performingRequest = false;
                    this.errorMsg = err.message;
                })
            },
            signup() {
                this.performingRequest = true;
                fb.auth.createUserWithEmailAndPassword(this.signupForm.email, this.signupForm.password).then(user => {
                    this.$store.commit('setCurrentUser', user);
                    // create user obj
                    fb.usersCollection.doc(user.uid).set({
                        name: this.signupForm.name,
                        title: this.signupForm.title
                    }).then(() => {
                        this.$store.dispatch('fetchUserProfile');
                        this.performingRequest = false;
                        this.$router.push('/dashboard');
                    }).catch(err => {
                        console.log(err);
                        this.performingRequest = false;
                        this.errorMsg = err.message;
                    })
                }).catch(err => {
                    console.log(err);
                    this.performingRequest = false;
                    this.errorMsg = err.message;
                });
            },
            resetPassword() {
                this.performingRequest = true;
                fb.auth.sendPasswordResetEmail(this.passwordForm.email).then(() => {
                    this.performingRequest = false;
                    this.passwordResetSuccess = true;
                    this.passwordForm.email = '';
                }).catch(err => {
                    console.log(err);
                    this.performingRequest = false;
                    this.errorMsg = err.message;
                });
            }
        }
    }
</script>

<style>
	.button {
		background-color: #FFCB3E;
		color: #384192;
	}
</style>
